(function () {
  'use strict';

  var cfg = window.MOBlumenCartContact || {};
  var TZ = 'Europe/Vienna';
  var DATE_KEY = 'Delivery Date';
  var TIME_KEY = 'Delivery Time';
  var cartState = { date: '', time: '' };
  var cartLoaded = false;
  var cartLoadPromise = null;
  var saveQueue = Promise.resolve();
  var initTimer = null;

  var copy = {
    de: {
      title: 'Lieferung (optional)',
      date: 'Lieferdatum (optional)',
      time: 'Lieferzeit (optional)',
      chooseTime: 'Zeit auswählen',
      chooseDateFirst: 'Bitte zuerst ein Datum wählen',
      hint: 'Same-Day nur bei Bestellung vor 12:00 Uhr. Lieferung von 11:00 bis 19:00 Uhr; heute frühestens 3 Stunden nach Bestellung.',
      noSlots: 'Für dieses Datum ist heute kein Zeitfenster mehr verfügbar.',
      gift: 'Geschenknachricht (optional)',
      giftPlaceholder: 'Ihre Nachricht für die beschenkte Person…',
      saved: 'Gespeichert',
      saveError: 'Konnte nicht gespeichert werden. Bitte erneut versuchen.'
    },
    en: {
      title: 'Delivery (optional)',
      date: 'Delivery date (optional)',
      time: 'Delivery time (optional)',
      chooseTime: 'Select a time',
      chooseDateFirst: 'Select a date first',
      hint: 'Same-day delivery is available for orders placed before 12:00. Delivery hours are 11:00–19:00; today starts at least 3 hours after ordering.',
      noSlots: 'No delivery window is available for this date today.',
      gift: 'Gift Message (optional)',
      giftPlaceholder: 'Your message to the recipient…',
      saved: 'Saved',
      saveError: 'Could not save. Please try again.'
    },
    ru: {
      title: 'Доставка (необязательно)',
      date: 'Дата доставки (необязательно)',
      time: 'Время доставки (необязательно)',
      chooseTime: 'Выберите время',
      chooseDateFirst: 'Сначала выберите дату',
      hint: 'Доставка в тот же день доступна для заказов до 12:00. Доставка с 11:00 до 19:00; сегодня — не ранее чем через 3 часа после заказа.',
      noSlots: 'На сегодня для этой даты больше нет доступного интервала.',
      gift: 'Сообщение к подарку (необязательно)',
      giftPlaceholder: 'Ваше сообщение получателю…',
      saved: 'Сохранено',
      saveError: 'Не удалось сохранить. Попробуйте еще раз.'
    },
    ar: {
      title: 'التوصيل (اختياري)',
      date: 'تاريخ التوصيل (اختياري)',
      time: 'وقت التوصيل (اختياري)',
      chooseTime: 'اختر الوقت',
      chooseDateFirst: 'اختر التاريخ أولاً',
      hint: 'التوصيل في نفس اليوم متاح للطلبات قبل 12:00. ساعات التوصيل من 11:00 إلى 19:00، وفي نفس اليوم يبدأ الموعد بعد 3 ساعات على الأقل من الطلب.',
      noSlots: 'لا توجد فترة توصيل متاحة لهذا التاريخ اليوم.',
      gift: 'رسالة الهدية (اختياري)',
      giftPlaceholder: 'اكتب رسالتك للمستلم…',
      saved: 'تم الحفظ',
      saveError: 'تعذر الحفظ. حاول مرة أخرى.'
    },
    tr: {
      title: 'Teslimat (isteğe bağlı)',
      date: 'Teslimat tarihi (isteğe bağlı)',
      time: 'Teslimat saati (isteğe bağlı)',
      chooseTime: 'Saat seçin',
      chooseDateFirst: 'Önce tarih seçin',
      hint: 'Aynı gün teslimat 12:00’den önce verilen siparişlerde mümkündür. Teslimat saatleri 11:00–19:00; bugün için en erken saat siparişten en az 3 saat sonradır.',
      noSlots: 'Bugün bu tarih için uygun teslimat aralığı kalmadı.',
      gift: 'Hediye mesajı (isteğe bağlı)',
      giftPlaceholder: 'Alıcıya mesajınız…',
      saved: 'Kaydedildi',
      saveError: 'Kaydedilemedi. Lütfen tekrar deneyin.'
    }
  };

  function langKey() {
    var raw = String(cfg.locale || document.documentElement.lang || 'de').toLowerCase();
    var key = raw.split('-')[0];
    return copy[key] ? key : 'de';
  }

  function t(key) {
    return copy[langKey()][key] || copy.de[key] || key;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function viennaParts(date) {
    var formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });
    var parts = formatter.formatToParts(date || new Date());
    var result = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') result[part.type] = part.value;
    });
    return {
      year: Number(result.year),
      month: Number(result.month),
      day: Number(result.day),
      hour: Number(result.hour),
      minute: Number(result.minute)
    };
  }

  function dateString(parts) {
    return parts.year + '-' + pad(parts.month) + '-' + pad(parts.day);
  }

  function addDays(isoDate, amount) {
    var bits = isoDate.split('-').map(Number);
    var d = new Date(Date.UTC(bits[0], bits[1] - 1, bits[2] + amount));
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }

  function timingSnapshot() {
    var now = new Date();
    var p = viennaParts(now);
    var today = dateString(p);
    var sameDayAllowed = p.hour < 12;
    return {
      now: now,
      parts: p,
      today: today,
      minDate: sameDayAllowed ? today : addDays(today, 1),
      sameDayAllowed: sameDayAllowed
    };
  }

  function allSlots() {
    var slots = [];
    for (var hour = 11; hour < 19; hour += 1) {
      slots.push(pad(hour) + ':00–' + pad(hour + 1) + ':00');
    }
    return slots;
  }

  function slotStart(slot) {
    return Number(String(slot).slice(0, 2));
  }

  function validSlotsFor(selectedDate) {
    if (!selectedDate) return [];
    var timing = timingSnapshot();
    if (selectedDate < timing.minDate) return [];
    var slots = allSlots();
    if (selectedDate !== timing.today) return slots;
    if (!timing.sameDayAllowed) return [];

    var plusThree = new Date(timing.now.getTime() + (3 * 60 * 60 * 1000));
    var after = viennaParts(plusThree);
    if (dateString(after) !== timing.today) return [];
    var earliestHour = after.hour + (after.minute > 0 ? 1 : 0);
    if (earliestHour < 11) earliestHour = 11;
    return slots.filter(function (slot) {
      return slotStart(slot) >= earliestHour;
    });
  }

  function normalizeState() {
    var changed = false;
    var timing = timingSnapshot();
    if (cartState.date && cartState.date < timing.minDate) {
      cartState.date = '';
      cartState.time = '';
      changed = true;
    }
    if (!cartState.date && cartState.time) {
      cartState.time = '';
      changed = true;
    }
    if (cartState.date && cartState.time) {
      var valid = validSlotsFor(cartState.date);
      if (valid.indexOf(cartState.time) === -1) {
        cartState.time = '';
        changed = true;
      }
    }
    return changed;
  }

  function cartJsUrl() {
    var base = cfg.cartUrl || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function loadCartState() {
    if (cartLoaded) return Promise.resolve(cartState);
    if (cartLoadPromise) return cartLoadPromise;
    cartLoadPromise = fetch(cartJsUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart read failed');
        return response.json();
      })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        cartState.date = attrs[DATE_KEY] || '';
        cartState.time = attrs[TIME_KEY] || '';
        cartLoaded = true;
        var changed = normalizeState();
        if (changed) saveAttributes();
        return cartState;
      })
      .catch(function () {
        cartLoaded = true;
        return cartState;
      });
    return cartLoadPromise;
  }

  function setStatus(message, isError) {
    document.querySelectorAll('[data-mo-delivery-status]').forEach(function (node) {
      node.textContent = message || '';
      node.setAttribute('aria-live', 'polite');
      node.style.opacity = isError ? '1' : '.72';
    });
    if (message && !isError) {
      window.setTimeout(function () {
        document.querySelectorAll('[data-mo-delivery-status]').forEach(function (node) {
          if (node.textContent === message) node.textContent = '';
        });
      }, 1200);
    }
  }

  function saveAttributes() {
    var snapshot = { date: cartState.date || '', time: cartState.time || '' };
    var url = cfg.cartUpdateUrl || '/cart/update.js';
    saveQueue = saveQueue.then(function () {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Delivery Date': snapshot.date,
            'Delivery Time': snapshot.time
          }
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        return response.json();
      }).then(function () {
        setStatus(t('saved'), false);
      });
    }).catch(function () {
      setStatus(t('saveError'), true);
    });
    return saveQueue;
  }

  function buildDeliveryBox(contextName) {
    var box = document.createElement('div');
    box.className = 'mo-delivery-options';
    box.setAttribute('data-mo-delivery-box', contextName);
    box.innerHTML =
      '<span class="mo-delivery-options__title">' + t('title') + '</span>' +
      '<div class="mo-delivery-options__grid">' +
        '<div class="mo-delivery-options__field">' +
          '<label for="mo-delivery-date-' + contextName + '">' + t('date') + '</label>' +
          '<input class="form-input-field" type="date" id="mo-delivery-date-' + contextName + '" data-mo-delivery-date>' +
        '</div>' +
        '<div class="mo-delivery-options__field">' +
          '<label for="mo-delivery-time-' + contextName + '">' + t('time') + '</label>' +
          '<select class="form-input-field" id="mo-delivery-time-' + contextName + '" data-mo-delivery-time></select>' +
        '</div>' +
      '</div>' +
      '<p class="mo-delivery-options__hint" data-mo-delivery-hint>' + t('hint') + '</p>' +
      '<p class="mo-delivery-options__status" data-mo-delivery-status></p>';

    var dateInput = box.querySelector('[data-mo-delivery-date]');
    var timeSelect = box.querySelector('[data-mo-delivery-time]');

    dateInput.addEventListener('change', function () {
      cartState.date = dateInput.value || '';
      if (!cartState.date) cartState.time = '';
      if (cartState.time && validSlotsFor(cartState.date).indexOf(cartState.time) === -1) {
        cartState.time = '';
      }
      renderAllDeliveryFields();
      saveAttributes();
    });

    dateInput.addEventListener('focus', function () {
      normalizeState();
      renderAllDeliveryFields();
    });

    timeSelect.addEventListener('change', function () {
      cartState.time = timeSelect.value || '';
      renderAllDeliveryFields();
      saveAttributes();
    });

    return box;
  }

  function renderDeliveryBox(box) {
    var timing = timingSnapshot();
    var dateInput = box.querySelector('[data-mo-delivery-date]');
    var timeSelect = box.querySelector('[data-mo-delivery-time]');
    var hint = box.querySelector('[data-mo-delivery-hint]');
    if (!dateInput || !timeSelect) return;

    dateInput.min = timing.minDate;
    dateInput.value = cartState.date || '';

    var slots = validSlotsFor(cartState.date);
    while (timeSelect.firstChild) timeSelect.removeChild(timeSelect.firstChild);
    var blank = document.createElement('option');
    blank.value = '';
    blank.textContent = cartState.date ? t('chooseTime') : t('chooseDateFirst');
    timeSelect.appendChild(blank);

    slots.forEach(function (slot) {
      var option = document.createElement('option');
      option.value = slot;
      option.textContent = slot;
      timeSelect.appendChild(option);
    });

    timeSelect.disabled = !cartState.date || slots.length === 0;
    if (cartState.time && slots.indexOf(cartState.time) !== -1) timeSelect.value = cartState.time;
    else timeSelect.value = '';

    hint.textContent = cartState.date && slots.length === 0 ? t('noSlots') : t('hint');
  }

  function renderAllDeliveryFields() {
    document.querySelectorAll('[data-mo-delivery-box]').forEach(renderDeliveryBox);
  }

  function injectDeliveryOptions() {
    var targets = [
      { name: 'main', node: document.querySelector('#main-cart-summary .checkout-btns') },
      { name: 'drawer', node: document.querySelector('#minicart .minicart-total-wrapper .checkout-btns') }
    ];

    targets.forEach(function (target) {
      if (!target.node || !target.node.parentNode) return;
      var parent = target.node.parentNode;
      if (parent.querySelector('[data-mo-delivery-box="' + target.name + '"]')) return;
      parent.insertBefore(buildDeliveryBox(target.name), target.node);
    });
    renderAllDeliveryFields();
  }

  function enhanceGiftMessage() {
    document.querySelectorAll('cart-note').forEach(function (panel) {
      var textarea = panel.querySelector('textarea[data-cart-note], textarea[name="note"]');
      if (!textarea || textarea.hasAttribute('data-mo-gift-ready')) return;
      textarea.setAttribute('data-mo-gift-ready', 'true');
      textarea.setAttribute('maxlength', '200');
      textarea.setAttribute('aria-label', t('gift'));
      textarea.placeholder = t('giftPlaceholder');

      var heading = panel.querySelector('.cart-options-title');
      if (heading) heading.textContent = t('gift');
      var label = panel.querySelector('label');
      if (label) label.textContent = t('gift');

      var footer = panel.closest('cart-footer-content');
      if (footer) {
        var link = footer.querySelector('a[href="#ordernote"] span');
        if (link) link.textContent = t('gift');
      }

      var field = textarea.closest('.form-field') || textarea.parentNode;
      var counter = document.createElement('small');
      counter.className = 'mo-gift-counter';
      field.appendChild(counter);

      function updateCounter() {
        if (textarea.value.length > 200) textarea.value = textarea.value.slice(0, 200);
        counter.textContent = textarea.value.length + ' / 200';
      }

      textarea.addEventListener('input', updateCounter);
      updateCounter();
    });
  }

  function injectContactLauncher() {
    if (String(cfg.template || '').toLowerCase() !== 'index') return;
    if (document.getElementById('mo-contact-launcher')) return;

    var instagram = cfg.instagram || 'https://www.instagram.com/moblumen/';
    var whatsapp = 'https://wa.me/' + String(cfg.whatsapp || '436602214777').replace(/\D/g, '');
    var wrap = document.createElement('div');
    wrap.id = 'mo-contact-launcher';
    wrap.className = 'mo-contact-launcher';
    wrap.innerHTML =
      '<span class="mo-contact-launcher__greeting" role="status">Hello, can I help you?</span>' +
      '<button class="mo-contact-launcher__main" type="button" aria-label="Contact MO BLUMEN" aria-expanded="false" aria-controls="mo-contact-actions">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5.75h14a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2h-7.2L7.2 20.5v-3.25H5a2 2 0 0 1-2-2v-7.5a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="8" cy="11.5" r="1" fill="currentColor"/><circle cx="12" cy="11.5" r="1" fill="currentColor"/><circle cx="16" cy="11.5" r="1" fill="currentColor"/></svg>' +
      '</button>' +
      '<div class="mo-contact-launcher__actions" id="mo-contact-actions">' +
        '<a class="mo-contact-launcher__action" href="' + whatsapp + '" target="_blank" rel="nofollow noopener noreferrer" aria-label="WhatsApp">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3.25a8.5 8.5 0 0 0-7.36 12.76L3.5 20.5l4.6-1.1A8.5 8.5 0 1 0 12 3.25Z" stroke="currentColor" stroke-width="1.65" stroke-linejoin="round"/><path d="M9.1 8.35c.2-.46.4-.47.7-.48h.6c.18 0 .38.07.48.3l.86 2.04c.08.2.04.37-.08.54l-.63.78c-.13.16-.11.31 0 .5.46.78 1.15 1.48 1.94 1.94.18.11.33.13.49 0l.8-.62c.17-.13.34-.17.54-.08l2.02.88c.23.1.3.3.3.48 0 .2-.1 1.22-.7 1.76-.58.53-1.35.72-2.15.5-1.02-.27-2.2-.78-3.64-2.05-1.17-1.03-2.2-2.3-2.62-3.39-.31-.8-.19-1.65.24-2.31.22-.34.53-.6.85-.79Z" fill="currentColor"/></svg>' +
        '</a>' +
        '<a class="mo-contact-launcher__action" href="' + instagram + '" target="_blank" rel="noopener noreferrer" aria-label="Instagram">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="5" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="3.6" stroke="currentColor" stroke-width="1.7"/><circle cx="17.25" cy="6.9" r="1" fill="currentColor"/></svg>' +
        '</a>' +
      '</div>';
    document.body.appendChild(wrap);

    var button = wrap.querySelector('.mo-contact-launcher__main');
    button.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target) && wrap.classList.contains('is-open')) {
        wrap.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && wrap.classList.contains('is-open')) {
        wrap.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
    });

    function syncCartVisibility() {
      var cart = document.querySelector('.minicart-panel.side-drawer-panel');
      var active = !!(cart && cart.classList.contains('active'));
      wrap.classList.toggle('is-cart-hidden', active);
      if (active) {
        wrap.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
    }

    var cart = document.querySelector('.minicart-panel.side-drawer-panel');
    if (cart) {
      new MutationObserver(syncCartVisibility).observe(cart, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    syncCartVisibility();

    window.setTimeout(function () {
      wrap.classList.add('is-visible');
      wrap.classList.add('show-greeting');
      window.setTimeout(function () {
        wrap.classList.remove('show-greeting');
      }, 2000);
    }, 3000);
  }

  function initializeCartUi() {
    enhanceGiftMessage();
    loadCartState().then(function () {
      injectDeliveryOptions();
      renderAllDeliveryFields();
    });
  }

  function scheduleInit() {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(initializeCartUi, 80);
  }

  function relevantCartMutation(mutations) {
    var selector = 'cart-note, cart-items, #main-cart-summary, #minicart, .checkout-btns';
    return mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes || []).some(function (node) {
        if (!node || node.nodeType !== 1) return false;
        if (node.matches && node.matches(selector)) return true;
        return !!(node.querySelector && node.querySelector(selector));
      });
    });
  }

  function boot() {
    initializeCartUi();
    injectContactLauncher();

    new MutationObserver(function (mutations) {
      if (relevantCartMutation(mutations)) scheduleInit();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        var changed = normalizeState();
        renderAllDeliveryFields();
        if (changed) saveAttributes();
      }
    });

    window.setInterval(function () {
      if (!document.querySelector('[data-mo-delivery-box]')) return;
      var changed = normalizeState();
      renderAllDeliveryFields();
      if (changed) saveAttributes();
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
